<script setup>

</script>

<template>
<section>
  <img src="/images/muebles.jpg" nopointer noselect>

  <div class="motivos-info-desktop">
    <h3 noselect class="mb-4">¿Te encontras en alguna de estas situaciones?</h3>
    <ul>
      <li><p noselect>Adquiriste una CASA, PH o DEPARTAMENTO EXCEPCIONAL, con un gran potencial, pero no estás seguro de cómo optimizar sus posibilidades.</p></li>
      <li><p noselect>Con el tiempo, tu familia y estilo de vida han evolucionado, y el espacio en el que siempre viviste ha quedado pequeño. Por el bienestar de tu familia, es necesario realizar una remodelación.</p></li>
      <li><p noselect>Sueñas con tener una de esas propiedades modernas y sofisticadas que suelen aparecer en revistas y redes sociales, pero no sabes por dónde comenzar para hacer realidad esa visión.</p></li>
    </ul>
  </div>

  <div class="motivos-info-mobile" flex flex-center flex-column>
    <h3 noselect class="mb-4">¿Te encontras en alguna de estas situaciones?</h3>
    <ul>
      <li><p noselect>Adquiriste una CASA, PH o DEPARTAMENTO EXCEPCIONAL, con un gran potencial, pero no estás seguro de cómo optimizar sus posibilidades.</p></li>
      <li><p noselect>Con el tiempo, tu familia y estilo de vida han evolucionado, y el espacio en el que siempre viviste ha quedado pequeño. Por el bienestar de tu familia, es necesario realizar una remodelación.</p></li>
      <li><p noselect>Sueñas con tener una de esas propiedades modernas y sofisticadas que suelen aparecer en revistas y redes sociales, pero no sabes por dónde comenzar para hacer realidad esa visión.</p></li>
    </ul>
  </div>
</section>
</template>

<style scoped lang="scss">
img {
  width: 100%;
  height: 400px;
  max-width: 700px;
  object-fit: cover;
}

section {
  padding: 3em;
  position: relative;

  min-height: unset !important;
  height: unset !important;
  padding: 4em;
}


.motivos-info-desktop {
  position: absolute;
  top: 6em;
  right: 0;
  max-width: 700px;
  width: 100%;
  height: 400px;

  background: white;
}

.motivos-info-mobile {
  display: none !important;
}

.motivos-info-mobile, .motivos-info-desktop {
  padding: 2em;
}

@media screen and (min-width: 1400px) {
  img {
    width: 100% !important;
    max-width: 80% !important;
  }

  .motivos-info-desktop {
    top: 6em;
    right: 6em;
  }
}


@media screen and (max-width: 830px) {
  img {
    display: none;
  }

  section {
    padding: 1em;
    display: flex;
    align-items: center;
    justify-content: center;

    height: calc(100vh - var(--header-height));
  }

  .motivos-info-desktop {
    display: none;
  }

  .motivos-info-mobile {
    display: block !important;
    margin: auto;
    width: 90%;
    height: fit-content;

    background: white;
  }
}
</style>